import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import SidebarListItem from "./SidebarListItem";
import { createSelector } from "@reduxjs/toolkit";
import {
  formatTime,
  mostRecentMessage,
  getOtherPersonUid,
  getPreviewText,
} from "../util";

const DmListItem = (props) => {
  const selectMessages = (state) =>
    state?.data?.previewMessages?.[props?.channelUid];

  const selectMostRecentMessage = createSelector(selectMessages, (messages) => {
    if (!messages) return null;
    return mostRecentMessage(Object.values(messages));
  });

  const messageForPreview = useSelector(selectMostRecentMessage);
  const channelLastViewed = (state) =>
    state?.data?.lastViewed?.[props?.channelUid];

  const selectIsUnread = createSelector(
    selectMostRecentMessage,
    channelLastViewed,
    (message, channelLastViewed) => {
      if (!message) {
        return false;
      }

      return !channelLastViewed || message?.createdAt > channelLastViewed;
    }
  );

  const isUnread = useSelector(selectIsUnread);
  const isNew = useSelector(
    (state) => !Boolean(state?.data?.lastViewed?.[props?.channelUid])
  );
  const isPinned = useSelector(
    (state) => state?.data?.myself?.pinnedGroups?.[props?.channelUid]
  );
  const otherPersonUid = useSelector((state) =>
    getOtherPersonUid(state?.data?.myself?.uid, props?.channelUid)
  );

  const channelObj = useSelector(
    (state) => state?.data?.channels?.[props?.channelUid]
  );

  const selectOtherPersonName = (state) =>
    state?.data?.users?.[otherPersonUid]?.name;
  const otherPersonName = useSelector(selectOtherPersonName);

  const selectGroupSearchQuery = (state) => state?.data?.groupSearchQuery;

  const selectIsFilteredFromSearch = createSelector(
    selectGroupSearchQuery,
    selectOtherPersonName,
    (searchQuery, otherPersonName) => {
      if (searchQuery.length === 0) return false;
      if (!otherPersonName) return false;
      return !otherPersonName.toLowerCase().includes(searchQuery.toLowerCase());
    }
  );

  const isFilteredFromSearch = useSelector(selectIsFilteredFromSearch);
  if (isFilteredFromSearch) return null;
  return (
    <SidebarListItem
      isUnread={isUnread}
      isNew={isNew}
      isPinned={isPinned}
      isMuted={false}
      header={otherPersonName ?? "DM"}
      preview={getPreviewText(messageForPreview, otherPersonName)}
      time={formatTime(messageForPreview?.createdAt ?? 0)}
      userUid={otherPersonUid}
      timestamp={messageForPreview?.createdAt ?? 0}
      channelUid={props?.channelUid}
    />
  );
};

export default DmListItem;
